import { useQuery } from '@tanstack/react-query'
import { fetchOrgFunctionalChecklistById } from '../services/fuctional_checklist'

const GetOrgFunctionalChecklistById = (checklistId) => {
 const orgFunctionalChecklist = useQuery({
    queryKey:['functional_checklist', checklistId],
    queryFn: () => fetchOrgFunctionalChecklistById(checklistId)
 })
 return orgFunctionalChecklist;
}

export default GetOrgFunctionalChecklistById